/* eslint-disable no-undef */
import React, {useState, useEffect} from 'react'
import {Box, Grid, Typography} from '@mui/material'
import {useDispatch, useSelector} from 'react-redux'
import {decode as base64Decode} from 'base-64'
import {AlertMessage, CustomButton, CustomTextBox, Loader} from '../../../components'
import {
  getModelListAction, getAppraiserTrueAction, postModelAction,
} from '../../../redux/admin/AdminActions'
import {adminListActions} from '../../../redux/admin/admin'
import {ManageModelTable} from './components'
import MyDiv from './manageModel.style'

export default function ManageModel() {

  const dispatch = useDispatch()
  const [addValue, setAddValue] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [modelList, setModelList] = useState()
  const [filteredModelList, setFilteredModelList] = useState([])
  const [message, setMessage] = useState('')
  const [status, setStatus] = useState('')

  const adminState = useSelector((state) => state.admin)
  let userId = localStorage.getItem('userId')

  let projectIDCrm = localStorage.getItem('project_id_crm')
  let decodedProjectId = base64Decode(projectIDCrm) // This is a Base64 encoded string

  const appraiserTrue = {
    getAppraisersOnly: true,
    project_id_crm: decodedProjectId,
  }

  useEffect(() => {
    dispatch(getModelListAction())
    dispatch(getAppraiserTrueAction(appraiserTrue))
  }, [dispatch])

  useEffect(() => {
    setModelList(adminState?.modelList?.modelList)
    setFilteredModelList(adminState?.modelList?.modelList)
  }, [adminState?.modelList?.modelList])

  useEffect(() => {
    if (adminState?.messageData.status === 'success') {
      setMessage(adminState?.messageData?.message)
      setStatus('success')
      setAddValue('')
    }
    if (adminState?.messageData.status === 'failed') {
      setMessage(adminState?.messageData?.message)
      setStatus('warning')
    }
  }, [adminState?.messageData])

  const handleMessageData = (value, type) => {
    setMessage(value)
    setStatus(type)
  }

  const handleSearchName = () => {
    if (searchValue !== '') {
      const result = modelList.filter((item) => {
        return item?.name?.toLowerCase().includes(searchValue.toLowerCase())
      })
      setFilteredModelList(result)
    } else {
      setFilteredModelList(modelList)
    }
  }

  const handleChange = (e) => {
    setSearchValue(e.target.value)
  }

  const handleReset = () => {
    window.location.reload()
    // setSearchValue('')
    // dispatch(getModelListAction())
  }

  const handleChangeAdd = (e) => {
    setAddValue(e.target.value)
  }

  const handleAdd = () => {
    if (!addValue) {
      setMessage('Please Enter Model Label')
      setStatus('warning')
      return
    }
    let addObj = {
      created_by: Number(userId),
      modified_by: Number(userId),
      name: addValue,
    }
    dispatch(postModelAction(addObj, 'add'))
  }

  const handleSnackBarClose = () => {
    setTimeout(() => {
      setMessage('')
      setStatus('')
      dispatch(adminListActions.clearMessageData())
    }, 2000)
  }


  return (
    <MyDiv>
      {(adminState?.modelList?.loading || adminState?.deleteModel?.loading || adminState?.postModel?.loading) &&
      <div>
        <Loader />
      </div>
      }
      <Box className="page_heading">
        <Typography>Manage Model Labels</Typography>
      </Box>
      <Box className="admin_card">
        <Grid container className="main_container">
          <Grid item md={4} className="d-flex">
            <Box className="input_box">
              <Typography>Model Label</Typography>
              <CustomTextBox name="label_add" value={addValue} onChange={handleChangeAdd} />
            </Box>
            <CustomButton title="Add" className="btn_theme" variant="contained" onClick={handleAdd} />
          </Grid>
          <Grid item md={4} />
          <Grid item md={4} className="d-flex">
            <Box className="input_box">
              <Typography>Search String</Typography>
              <CustomTextBox name="search_model" value={searchValue} onChange={handleChange} />
            </Box>
            <Box className="d-flex">
              <CustomButton title="Search" className="btn_theme" variant="contained" onClick={handleSearchName} />
              <CustomButton title="Reset" className="btn_reset" variant="contained" onClick={handleReset} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      {filteredModelList?.length > 0 ?
        <ManageModelTable messageData={handleMessageData} filteredModelList={filteredModelList} searchValue={searchValue} /> :
        <Box className="no-data">
          <Typography>No Data Available</Typography>
        </Box>
      }
      <AlertMessage
        message={message}
        severity={status}
        open={message?.length > 0}
        close={handleSnackBarClose}
      />
    </MyDiv>
  )
}
